import cn from 'classnames';

import { IConDefaultType } from '../..';

export enum RankingIconVariant {
  UP = 'up',
  DOWN = 'down',
  NORMAL = 'normal',
}
export interface IRankingIconProps extends IConDefaultType {
  variant?: RankingIconVariant;
}

export default function RankingIcon({
  className,
  size = 16,
  rotate,
  flip,
  variant = RankingIconVariant.UP,
}: IRankingIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === RankingIconVariant.UP && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path d="M12 8H9V12H7V8H4L8 4L12 8Z" fill="#F6375A" />
        </svg>
      )}
      {variant === RankingIconVariant.DOWN && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path d="M12 8H9V4H7V8H4L8 12L12 8Z" fill="#229BDC" />
        </svg>
      )}
      {variant === RankingIconVariant.NORMAL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <rect x="4" y="7" width="8" height="2" fill="black" fill-opacity="0.6" />
        </svg>
      )}
    </i>
  );
}
